import thunk from "redux-thunk";
import RootReducer from "./rootReducer";
import { createLogger } from "redux-logger";
import { persistStore, persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import { legacy_createStore, applyMiddleware, compose } from "redux";

const logger: any = createLogger({
  predicate: () => process.env.NODE_ENV === "development",
});

const enhancer = compose(applyMiddleware(thunk, logger));

const persistConfig = {
  key: "root",
  blacklist: [],
  storage: storageSession,
  whitelist: ["AuthReducer"],
};

const persistedReducer = persistReducer(persistConfig, RootReducer);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

/**
 * create new store
 */
export const store = legacy_createStore(persistedReducer, enhancer);
export const persistor = persistStore(store);
